{
  "%d people": "%d people",
  "%d zones": "%d zones",
  "%s added %s": "%s added %s",
  "%s added you": "%s added you",
  "%s allowed all members to edit the group info": "%s allowed all members to edit the group info",
  "%s and %s": "%s and %s",
  "%s changed the group description": "%s changed the group description",
  "%s changed the group icon": "%s changed the group icon",
  "%s changed the group name to “%s”": "%s changed the group name to “%s”",
  "%s left": "%s left",
  "%s made %s a moderator": "%s made %s a moderator",
  "%s made %s an admin": "%s made %s an admin",
  "%s made you a moderator": "%s made you a moderator",
  "%s made you an admin": "%s made you an admin",
  "%s must update WaveTalk before anyone can write here": "%s must update WaveTalk before anyone can write here",
  "%s removed %s": "%s removed %s",
  "%s removed %s as an admin": "%s removed %s as an admin",
  "%s removed the group description": "%s removed the group description",
  "%s removed the group icon": "%s removed the group icon",
  "%s removed you": "%s removed you",
  "%s removed you as an admin": "%s removed you as an admin",
  "%s requests": "%s requests",
  "%s restricted editing the group info to admins": "%s restricted editing the group info to admins",
  "%s turned off disappearing messages": "%s turned off disappearing messages",
  "%s turned on disappearing messages: %s": "%s turned on disappearing messages: %s",
  "%s updated WaveTalk. Messages here are end-to-end encrypted.": "%s updated WaveTalk. Messages here are end-to-end encrypted.",
  "%s, %s": "%s, %s",
  "+ Hide from someone…": "+ Hide from someone…",
  "1 person": "1 person",
  "1 zone": "1 zone",
  "24 hours": "24 hours",
  "6-digit code": "6-digit code",
  "7 days": "7 days",
  "90 days": "90 days",
  "A channel is an account that broadcasts — a shop, a station, a church, an office. People follow it and see what you post on their Updates. Nobody can reply.": "A channel is an account that broadcasts — a shop, a station, a church, an office. People follow it and see what you post on their Updates. Nobody can reply.",
  "A language arrives complete or not at all.": "A language arrives complete or not at all.",
  "A post stays until you delete it. Only the people you choose can see it, and it is not end-to-end encrypted.": "A post stays until you delete it. Only the people you choose can see it, and it is not end-to-end encrypted.",
  "Activity": "Activity",
  "Add a comment": "Add a comment",
  "Add status": "Add status",
  "Admin": "Admin",
  "Airtel Money": "Airtel Money",
  "All": "All",
  "An organisation is a shop, a church committee, a school or an NGO — the people you work with, and the conversations that belong to the group rather than to whoever started them.": "An organisation is a shop, a church committee, a school or an NGO — the people you work with, and the conversations that belong to the group rather than to whoever started them.",
  "Anyone who finds you, including in search": "Anyone who finds you, including in search",
  "Appearance": "Appearance",
  "Audio": "Audio",
  "Build": "Build",
  "Built-in": "Built-in",
  "Call cancelled: %s": "Call cancelled: %s",
  "Call scheduled: %s": "Call scheduled: %s",
  "Cancel": "Cancel",
  "Channel": "Channel",
  "Channels": "Channels",
  "Channels you follow": "Channels you follow",
  "Chat wallpaper": "Chat wallpaper",
  "Chats": "Chats",
  "Choose a conversation to start.": "Choose a conversation to start.",
  "Choose photo…": "Choose photo…",
  "Chosen groups": "Chosen groups",
  "Circle": "Circle",
  "Close": "Close",
  "Colour": "Colour",
  "Coming: %s": "Coming: %s",
  "Comment": "Comment",
  "Compare this number with your contact's, in person or over a call you trust. If they match, your conversation is end-to-end encrypted and no one in the middle can read it.": "Compare this number with your contact's, in person or over a call you trust. If they match, your conversation is end-to-end encrypted and no one in the middle can read it.",
  "Confirm on your phone": "Confirm on your phone",
  "Confirm payment": "Confirm payment",
  "Connecting…": "Connecting…",
  "Contact": "Contact",
  "Contact email": "Contact email",
  "Contact phone": "Contact phone",
  "Could not change that. Try again.": "Could not change that. Try again.",
  "Could not load channels.": "Could not load channels.",
  "Could not load this channel.": "Could not load this channel.",
  "Couldn't change who can see your status.": "Couldn't change who can see your status.",
  "Couldn't delete that comment.": "Couldn't delete that comment.",
  "Couldn't delete that post.": "Couldn't delete that post.",
  "Couldn't delete that.": "Couldn't delete that.",
  "Couldn't load that list.": "Couldn't load that list.",
  "Couldn't load the frames.": "Couldn't load the frames.",
  "Couldn't load the sticker pack.": "Couldn't load the sticker pack.",
  "Couldn't load your channels.": "Couldn't load your channels.",
  "Couldn't mute that person.": "Couldn't mute that person.",
  "Couldn't open that thread.": "Couldn't open that thread.",
  "Couldn't post that comment.": "Couldn't post that comment.",
  "Couldn't post that status.": "Couldn't post that status.",
  "Couldn't publish that post.": "Couldn't publish that post.",
  "Couldn't send the report. Try again.": "Couldn't send the report. Try again.",
  "Create": "Create",
  "Create a channel": "Create a channel",
  "Create an organisation": "Create an organisation",
  "Create organisation": "Create organisation",
  "Create zone": "Create zone",
  "Creating…": "Creating…",
  "Current": "Current",
  "Dark": "Dark",
  "Delete": "Delete",
  "Discover": "Discover",
  "Done": "Done",
  "Earlier photo": "Earlier photo",
  "Enter your username and password": "Enter your username and password",
  "Enter your verification code": "Enter your verification code",
  "Everyone": "Everyone",
  "Explicit content": "Explicit content",
  "Explore": "Explore",
  "Explore all channels": "Explore all channels",
  "Failed to load": "Failed to load",
  "Featured": "Featured",
  "File": "File",
  "Fill in everything above first.": "Fill in everything above first.",
  "Find channels to follow": "Find channels to follow",
  "Follow": "Follow",
  "Follow my browser": "Follow my browser",
  "Follow my device": "Follow my device",
  "Following": "Following",
  "For you": "For you",
  "Frame": "Frame",
  "Frame…": "Frame…",
  "Fri": "Fri",
  "From here, messages in this chat are end-to-end encrypted": "From here, messages in this chat are end-to-end encrypted",
  "Generating code…": "Generating code…",
  "Get a new code": "Get a new code",
  "Ghost · 24h": "Ghost · 24h",
  "Group call": "Group call",
  "Group call · %s": "Group call · %s",
  "Group video call": "Group video call",
  "Group video call · %s": "Group video call · %s",
  "Handle": "Handle",
  "Handle: @%s. This cannot be changed later.": "Handle: @%s. This cannot be changed later.",
  "Harassment or bullying": "Harassment or bullying",
  "Hide your photo from…": "Hide your photo from…",
  "Hide your photo from… (name, @username, or phone)": "Hide your photo from… (name, @username, or phone)",
  "In %d organisations": "In %d organisations",
  "Indigo": "Indigo",
  "Installed": "Installed",
  "Language": "Language",
  "Leave organisation": "Leave organisation",
  "Let somebody scan this to message you.": "Let somebody scan this to message you.",
  "Light": "Light",
  "Liked": "Liked",
  "Loading mini-apps…": "Loading mini-apps…",
  "Loading…": "Loading…",
  "M-Pesa": "M-Pesa",
  "Make admin": "Make admin",
  "Mazungumzo": "Mazungumzo",
  "Member": "Member",
  "Mentions": "Mentions",
  "Message": "Message",
  "Message failed to send": "Message failed to send",
  "Messages in this chat aren't end-to-end encrypted.": "Messages in this chat aren't end-to-end encrypted.",
  "Mini-app": "Mini-app",
  "Mini-apps": "Mini-apps",
  "Mixx by Yas": "Mixx by Yas",
  "Mon": "Mon",
  "Mute": "Mute",
  "My QR code": "My QR code",
  "My status": "My status",
  "Name": "Name",
  "Never sent a message": "Never sent a message",
  "New channel": "New channel",
  "New organisation": "New organisation",
  "New post": "New post",
  "New status": "New status",
  "New zone": "New zone",
  "No channels yet. When publishers arrive, they show up here.": "No channels yet. When publishers arrive, they show up here.",
  "No connection": "No connection",
  "No conversations yet": "No conversations yet",
  "No installed apps yet": "No installed apps yet",
  "No messages yet": "No messages yet",
  "No mini-apps available yet": "No mini-apps available yet",
  "No safety number yet — it appears once you've exchanged an encrypted message with this contact.": "No safety number yet — it appears once you've exchanged an encrypted message with this contact.",
  "No views yet": "No views yet",
  "No zones yet.": "No zones yet.",
  "Nobody": "Nobody",
  "Nobody has said anything in public yet. When they do, it shows up here.": "Nobody has said anything in public yet. When they do, it shows up here.",
  "None": "None",
  "Not on WaveTalk": "Not on WaveTalk",
  "Not publishing": "Not publishing",
  "Not used recently": "Not used recently",
  "Nothing found.": "Nothing found.",
  "Nothing liked yet.": "Nothing liked yet.",
  "Nothing posted yet.": "Nothing posted yet.",
  "Nothing posted yet. Write one, and the people you chat with will see it.": "Nothing posted yet. Write one, and the people you chat with will see it.",
  "Nothing saved yet.": "Nothing saved yet.",
  "Nothing up right now. A status disappears after 24 hours.": "Nothing up right now. A status disappears after 24 hours.",
  "Nothing yet from the people you follow.": "Nothing yet from the people you follow.",
  "Nothing yet.": "Nothing yet.",
  "Notification": "Notification",
  "OK": "OK",
  "Office": "Office",
  "Office zone. WaveTalk's servers can read this zone so an assistant can take part. It is not end-to-end encrypted.": "Office zone. WaveTalk's servers can read this zone so an assistant can take part. It is not end-to-end encrypted.",
  "Office — your channels": "Office — your channels",
  "One line, shown in Explore": "One line, shown in Explore",
  "Online": "Online",
  "Only me": "Only me",
  "Only people you have replied to in a direct chat": "Only people you have replied to in a direct chat",
  "Only share with…": "Only share with…",
  "Only the people I picked": "Only the people I picked",
  "Only the people you choose can see this. Status is not end-to-end encrypted.": "Only the people you choose can see this. Status is not end-to-end encrypted.",
  "Only you": "Only you",
  "Open WaveTalk on your phone → Settings → Scan to log in": "Open WaveTalk on your phone → Settings → Scan to log in",
  "Ops": "Ops",
  "Organisation name": "Organisation name",
  "Organisations": "Organisations",
  "Owner": "Owner",
  "Password": "Password",
  "Pay %s %s": "Pay %s %s",
  "Pay with": "Pay with",
  "People": "People",
  "People I chat with": "People I chat with",
  "People can follow this and see what you post.": "People can follow this and see what you post.",
  "People you follow": "People you follow",
  "Phone number (e.g. 0712 345 678)": "Phone number (e.g. 0712 345 678)",
  "Photo": "Photo",
  "Photo history — only you see this": "Photo history — only you see this",
  "Photo history…": "Photo history…",
  "Pick a sticker": "Pick a sticker",
  "Pick an emoji": "Pick an emoji",
  "Plain": "Plain",
  "Post": "Post",
  "Post comment": "Post comment",
  "Posting…": "Posting…",
  "Posts": "Posts",
  "Pretending to be someone else": "Pretending to be someone else",
  "Processing…": "Processing…",
  "Profile": "Profile",
  "Profile photo": "Profile photo",
  "Publish to people who follow you": "Publish to people who follow you",
  "Publishing": "Publishing",
  "Publishing is off, so nobody can follow this yet.": "Publishing is off, so nobody can follow this yet.",
  "Quote": "Quote",
  "Remove": "Remove",
  "Remove as admin": "Remove as admin",
  "Remove photo": "Remove photo",
  "Rename": "Rename",
  "Reply": "Reply",
  "Report": "Report",
  "Reported. Thank you — we'll review it.": "Reported. Thank you — we'll review it.",
  "Repost": "Repost",
  "Right now that is %s": "Right now that is %s",
  "Right now the only way anyone can find you is by typing @%s exactly. Add the name people actually call you and they will find you by that instead.": "Right now the only way anyone can find you is by typing @%s exactly. Add the name people actually call you and they will find you by that instead.",
  "Rose": "Rose",
  "Sales": "Sales",
  "Sand": "Sand",
  "Sat": "Sat",
  "Save": "Save",
  "Saved": "Saved",
  "Saved in this browser. We will sync it to your account when you are back online.": "Saved in this browser. We will sync it to your account when you are back online.",
  "Say hello 👋": "Say hello 👋",
  "Scam or fraud": "Scam or fraud",
  "Scan with WaveTalk on your phone": "Scan with WaveTalk on your phone",
  "Scan with phone instead": "Scan with phone instead",
  "Search": "Search",
  "Search Mazungumzo": "Search Mazungumzo",
  "Search channels": "Search channels",
  "Search mini-apps": "Search mini-apps",
  "Send": "Send",
  "Session": "Session",
  "Sign in": "Sign in",
  "Sign in with password instead": "Sign in with password instead",
  "Sign out": "Sign out",
  "Sign-in was declined on your phone": "Sign-in was declined on your phone",
  "Signing in…": "Signing in…",
  "Slate": "Slate",
  "Someone": "Someone",
  "Someone who has your number in their contacts can find you": "Someone who has your number in their contacts can find you",
  "Something else": "Something else",
  "Spam": "Spam",
  "Starting camera…": "Starting camera…",
  "Sticker": "Sticker",
  "Support": "Support",
  "Syncing your chats…": "Syncing your chats…",
  "Syncing your chats… %s%": "Syncing your chats… %s%",
  "Teal": "Teal",
  "That didn't work. Try again.": "That didn't work. Try again.",
  "That handle is already taken. Try another.": "That handle is already taken. Try another.",
  "That post wasn't published.": "That post wasn't published.",
  "The handle is unique and permanent. Lower case, no spaces.": "The handle is unique and permanent. Lower case, no spaces.",
  "The language WaveTalk is read in": "The language WaveTalk is read in",
  "This browser is not a linked device, so it cannot read this chat. Open WaveTalk on your phone → Settings → Scan to log in.": "This browser is not a linked device, so it cannot read this chat. Open WaveTalk on your phone → Settings → Scan to log in.",
  "This changes WaveTalk only.": "This changes WaveTalk only.",
  "This channel has not posted yet.": "This channel has not posted yet.",
  "This chat is end-to-end encrypted. You can only read and write it on your phone.": "This chat is end-to-end encrypted. You can only read and write it on your phone.",
  "This code expired": "This code expired",
  "This is remembered in this browser, not on your account — a bright desk and a dark phone want different answers.": "This is remembered in this browser, not on your account — a bright desk and a dark phone want different answers.",
  "This message can't be read on this device": "This message can't be read on this device",
  "This message was deleted": "This message was deleted",
  "This number is for this browser and %s's device %s. Each device has its own key, so your phone shows a different number for the same person.": "This number is for this browser and %s's device %s. Each device has its own key, so your phone shows a different number for the same person.",
  "This post is no longer available.": "This post is no longer available.",
  "Thu": "Thu",
  "Tue": "Tue",
  "Type a status": "Type a status",
  "Update WaveTalk to keep chatting here": "Update WaveTalk to keep chatting here",
  "Updates": "Updates",
  "Use": "Use",
  "Use a sticker…": "Use a sticker…",
  "Use an emoji…": "Use an emoji…",
  "Username or phone": "Username or phone",
  "Verify": "Verify",
  "Verify security": "Verify security",
  "Verifying…": "Verifying…",
  "Video": "Video",
  "Voice": "Voice",
  "Voice note": "Voice note",
  "WaveTalk": "WaveTalk",
  "WaveTalk on your computer": "WaveTalk on your computer",
  "Wed": "Wed",
  "What does it trade in?": "What does it trade in?",
  "What is it? (optional)": "What is it? (optional)",
  "What is this zone for?": "What is this zone for?",
  "What kind of publisher is this?": "What kind of publisher is this?",
  "What people see": "What people see",
  "What's being said": "What's being said",
  "What's happening?": "What's happening?",
  "When this is set to Nobody, someone typing your number finds nothing — the same as if you had never registered. Your name and @handle can still be searched.": "When this is set to Nobody, someone typing your number finds nothing — the same as if you had never registered. Your name and @handle can still be searched.",
  "Who can find me by my phone number": "Who can find me by my phone number",
  "Who can see it": "Who can see it",
  "Who can see your photo": "Who can see your photo",
  "Why are you reporting this?": "Why are you reporting this?",
  "Work together in one place": "Work together in one place",
  "World": "World",
  "Write to your followers": "Write to your followers",
  "Yesterday": "Yesterday",
  "You added %s": "You added %s",
  "You allowed all members to edit the group info": "You allowed all members to edit the group info",
  "You can read this chat here, but sending is only on your phone for now.": "You can read this chat here, but sending is only on your phone for now.",
  "You changed the group description": "You changed the group description",
  "You changed the group icon": "You changed the group icon",
  "You changed the group name to “%s”": "You changed the group name to “%s”",
  "You left": "You left",
  "You made %s a moderator": "You made %s a moderator",
  "You made %s an admin": "You made %s an admin",
  "You removed %s": "You removed %s",
  "You removed %s as an admin": "You removed %s as an admin",
  "You removed the group description": "You removed the group description",
  "You removed the group icon": "You removed the group icon",
  "You restricted editing the group info to admins": "You restricted editing the group info to admins",
  "You turned off disappearing messages": "You turned off disappearing messages",
  "You turned on disappearing messages: %s": "You turned on disappearing messages: %s",
  "You updated WaveTalk. Messages here are end-to-end encrypted.": "You updated WaveTalk. Messages here are end-to-end encrypted.",
  "%s created the zone “%s”. It is not end-to-end encrypted: WaveTalk's servers can read it so an assistant can take part.": "%s created the zone “%s”. It is not end-to-end encrypted: WaveTalk's servers can read it so an assistant can take part.",
  "You're offline — a post has to reach people.": "You're offline — a post has to reach people.",
  "You're offline — a status has to reach people.": "You're offline — a status has to reach people.",
  "You're offline. A post has to reach your followers, so it waits.": "You're offline. A post has to reach your followers, so it waits.",
  "Your channels": "Your channels",
  "Your name": "Your name",
  "Your number finds nothing, as if you had never registered": "Your number finds nothing, as if you had never registered",
  "Your photo is not end-to-end encrypted — the WaveTalk service stores it so it can be shown to people you chat with.": "Your photo is not end-to-end encrypted — the WaveTalk service stores it so it can be shown to people you chat with.",
  "Zone": "Zone",
  "Zone name": "Zone name",
  "Zones": "Zones",
  "_comment": "WaveTalk web (Joana) — the base string catalogue (ADR-0028). English text is the key: t('Language') falls back to the key, so a missing translation renders as English and never as a raw identifier (D4). This file is the definitive LIST scripts/i18n-check.mjs measures every other locale against. Add a string here when you move it out of a hardcoded literal; scripts/i18n-literals.mjs counts the ones that are not here yet.",
  "just now": "just now",
  "quoted you": "quoted you",
  "replied to you": "replied to you",
  "reposted you": "reposted you",
  "typing…": "typing…",
  "unique, permanent": "unique, permanent",
  "‹ Back": "‹ Back",
  "← Thread": "← Thread",
  "⊞ Apps": "⊞ Apps",
  "◉ Capture": "◉ Capture",
  "◌ Updates": "◌ Updates",
  "◍ Updates": "◍ Updates",
  "♡ Like": "♡ Like",
  "♥ Liked": "♥ Liked",
  "✓ Scanned": "✓ Scanned",
  "✕ Close": "✕ Close",
  "🔗 Linked device": "🔗 Linked device",
  "Update WaveTalk to keep using it": "Update WaveTalk to keep using it",
  "Update WaveTalk to open this zone": "Update WaveTalk to open this zone",
  "This zone needs a newer version of WaveTalk. Your other chats work as usual.": "This zone needs a newer version of WaveTalk. Your other chats work as usual.",
  "This version is no longer supported. Install the latest one to send and receive messages again.": "This version is no longer supported. Install the latest one to send and receive messages again.",
  "Reload WaveTalk": "Reload WaveTalk",
  "Signing you in…": "Signing you in…",
  "Couldn't reach WaveTalk. Check your connection and reload, or sign in below.": "Couldn't reach WaveTalk. Check your connection and reload, or sign in below.",
  "Sign in to keep talking": "Sign in to keep talking",
  "1 follower": "1 follower",
  "%d followers": "%d followers",
  "Today": "Today",
  "Unknown": "Unknown",
  "Unmute": "Unmute",
  "Load older posts": "Load older posts",
  "Forward to": "Forward to",
  "Forwarded.": "Forwarded.",
  "Couldn't forward.": "Couldn't forward.",
  "Couldn't react. Try again.": "Couldn't react. Try again.",
  "%d days": "%d days",
  "A key lets a tool act as this organisation's assistant, only in zones where the assistant is on. Every use is recorded.": "A key lets a tool act as this organisation's assistant, only in zones where the assistant is on. Every use is recorded.",
  "API keys": "API keys",
  "Add assistant": "Add assistant",
  "Add": "Add",
  "An assistant can read the zones you switch it on in, and post there through a tool you give an API key. It is not a person and never signs in.": "An assistant can read the zones you switch it on in, and post there through a tool you give an API key. It is not a person and never signs in.",
  "Assistant in %s": "Assistant in %s",
  "Assistant in this zone": "Assistant in this zone",
  "Assistant name": "Assistant name",
  "Assistant": "Assistant",
  "Copied.": "Copied.",
  "Copy it now. You will not see this key again.": "Copy it now. You will not see this key again.",
  "Copy": "Copy",
  "Expires %s": "Expires %s",
  "For example: Ideas, Support": "For example: Ideas, Support",
  "Instructions": "Instructions",
  "Issue an API key": "Issue an API key",
  "Issue": "Issue",
  "Key name": "Key name",
  "Last used %s": "Last used %s",
  "Lasts": "Lasts",
  "Never used": "Never used",
  "Off": "Off",
  "On": "On",
  "On, as %s": "On, as %s",
  "Switched off": "Switched off",
  "Switched on": "Switched on",
  "Post in zones": "Post in zones",
  "Read zones": "Read zones",
  "Refused %d times — check where it is used": "Refused %d times — check where it is used",
  "Refused once — check where it is used": "Refused once — check where it is used",
  "Revoke “%s”? Anything using it stops working at once.": "Revoke “%s”? Anything using it stops working at once.",
  "Revoke": "Revoke",
  "Revoked %s": "Revoked %s",
  "Shape": "Shape",
  "Tap to rename": "Tap to rename",
  "The assistant belongs to this organisation. It has no phone number, never signs in, and reads only the zones you switch it on in.": "The assistant belongs to this organisation. It has no phone number, never signs in, and reads only the zones you switch it on in.",
  "What will use it": "What will use it",
  "When it is on, the assistant is a member of this zone and can read it. Everyone in the zone sees it join or leave.": "When it is on, the assistant is a member of this zone and can read it. Everyone in the zone sees it join or leave.",
  "Your new API key": "Your new API key",
  "%s Assistant": "%s Assistant",
  "Couldn't load that organisation.": "Couldn't load that organisation.",
  "Couldn't load your organisations.": "Couldn't load your organisations.",
  "That change wasn't made.": "That change wasn't made.",
  "That organisation wasn't created.": "That organisation wasn't created.",
  "You couldn't leave that organisation.": "You couldn't leave that organisation.",
  "You're offline.": "You're offline."
}
